/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ScheduleFinderDialogComponent } from './schedule-finder-dialog.component';

export const scheduleFinderDialogRoute = createDialogRoute({
  component: ScheduleFinderDialogComponent,
});
